var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Pipe } from '@angular/core';
var EllipsisPipe = /** @class */ (function () {
    function EllipsisPipe() {
    }
    EllipsisPipe.prototype.transform = function (value, chineseCount) {
        if (!value || value.length <= chineseCount) {
            return value;
        }
        var chineseLength = 0.0;
        for (var i = 0; i < value.length; i++) {
            if (/.*[\u4e00-\u9fa5]+.*/.test(value[i])) {
                chineseLength += 1;
            }
            else {
                chineseLength += 0.5;
            }
            if (chineseLength >= chineseCount) {
                return value.substring(0, i + 1) + "...";
            }
        }
        return value;
    };
    EllipsisPipe = __decorate([
        Pipe({ name: 'ellipsis' })
    ], EllipsisPipe);
    return EllipsisPipe;
}());
export { EllipsisPipe };
